export const hiIN: { [k: string]: string } = {
  // DO NOT REMOVE THIS COMMENT
  
}
